module.exports = __webpack_public_path__ + "static/media/default_user.782adc2b.png";